<template>
  <div :style="containerStyle">
    <div :style="innerContainerStyle">
      <HeaderLargeLight>
        Profile & Preference
      </HeaderLargeLight>
      <CardSecondary :style="cardStyle">
        <HeaderSmallPrimary>
          PROFILE
        </HeaderSmallPrimary>
        <validation-observer v-slot="{ invalid }"
                             :style="validationObserverStyle">
          <div :style="nameFormsContainerStyle">
            <FormNamePrimary label="First name"
                             placeholder="Your first name"
                             validationProviderName="first name"
                             v-model="newFirstName"
                             :style="firstNameFormStyle" />
            <FormNamePrimary label="Last name"
                             placeholder="Your last name"
                             validationProviderName="last name"
                             v-model="newLastName"
                             :style="lastNameFormStyle" />
          </div>
          <div :style="emailContainerStyle">
            <div :style="emailInnerContainerStyle">
              <LabelPrimary>
                Email address
              </LabelPrimary>
              <TextEmailPrimary>
                {{ email }}
              </TextEmailPrimary>
              <TextAnnotationPrimary v-if="isSsoUser">
                The email domain is configured for Single Sign On.
              </TextAnnotationPrimary>
            </div>
          </div>
          <div :style="lineStyle" />
          <UserPasswordForm :isSsoUser="isSsoUser" />
          <div :style="lineStyle" />
          <div :style="buttonsContainerStyle">
            <ButtonSecondary :disabled="!isEdited"
                             :style="buttonStyle"
                             @click="resetEdit">
              Cancel
            </ButtonSecondary>
            <ButtonPrimary :disabled="!isEdited || invalid"
                           :style="buttonStyle"
                           @click="updateUserProfile">
              Update
            </ButtonPrimary>
          </div>
        </validation-observer>
      </CardSecondary>
    </div>
  </div>
</template>

<script>
  import ApiCurrentUser from '@js/api/current-user'
  import ApiSsoEmailDomain from '@js/api/sso-email-domain'
  import ButtonPrimary from '@modules/button/button-primary'
  import ButtonSecondary from '@modules/button/button-secondary'
  import CardSecondary from '@modules/card/card-secondary'
  import FormNamePrimary from '@modules/form/form-name-primary'
  import HeaderLargeLight from '@modules/text/header-large-light'
  import HeaderSmallPrimary from '@modules/text/header-small-primary'
  import LabelPrimary from '@modules/input/label-primary'
  import TextAnnotationPrimary from '@modules/text/text-annotation-primary'
  import TextEmailPrimary from '@modules/text/text-email-primary'
  import UserPasswordForm from '@settings/modules/user-password-form'
  import { Layout } from '@js/styles'
  import { ValidationObserver } from 'vee-validate'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'UserProfileView',
    components: {
      ButtonPrimary,
      ButtonSecondary,
      CardSecondary,
      FormNamePrimary,
      HeaderLargeLight,
      HeaderSmallPrimary,
      LabelPrimary,
      TextAnnotationPrimary,
      TextEmailPrimary,
      UserPasswordForm,
      ValidationObserver,
    },
    data: function () {
      return {
        buttonsContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: Layout.space.xl,
          marginLeft: Layout.space.md,
        },
        buttonStyle: {
          display: 'block',
          minWidth: '86px',
          marginLeft: Layout.space.md,
        },
        cardStyle: {
          marginTop: Layout.space.lg,
          padding: Layout.space.lg,
        },
        containerStyle: {
          height: '600px',
        },
        emailContainerStyle: {
          alignItems: 'flex-end',
          display: 'flex',
          flex: 1,
          justifyContent: 'space-between',
          margin: `${Layout.space.lg} 0 0 0`,
        },
        emailInnerContainerStyle: {
          width: '100%',
        },
        firstNameFormStyle: {
          flex: 1,
          margin: `0 ${Layout.space.sm} 0 0`,
        },
        innerContainerStyle: {
          left: '50%',
          maxWidth: '608px',
          transform: 'translateX(-50%)',
          padding: `0 ${Layout.space.lg}`,
          position: 'absolute',
          width: '100%',
        },
        isSsoUser: false,
        lastNameFormStyle: {
          flex: 1,
          margin: `0 0 0 ${Layout.space.sm}`,
        },
        lineStyle: {
          height: '1px',
          margin: '32px 0',
          width: '100%',
        },
        nameFormsContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          margin: `${Layout.space.lg} 0 0 0`,
          width: '100%',
        },
        newFirstName: '',
        newLastName: '',
        validationObserverStyle: {
          width: '100%',
        },
      };
    },
    created: function () {
      this.newFirstName = this.firstName;
      this.newLastName = this.lastName;
      this.lineStyle.backgroundColor = this.color.dark5();
    },
    mounted: async function () {
      try {
        const payload = { email: this.email, };
        const api = new ApiSsoEmailDomain();
        const res = await api.post(payload);
        this.isSsoUser = await res.data.singleSignOn;
      } catch (error) {
        console.error(error);
      }
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      ...mapState({
        email: state => state.user.email,
        firstName: state => state.user.firstName,
        lastName: state => state.user.lastName,
      }),
      isEdited: function () {
        if (this.newFirstName !== this.firstName ||
            this.newLastName !== this.lastName) {
          return true;
        }
        return false;
      },
    },
    methods: {
      resetEdit: function () {
        this.newFirstName = this.firstName;
        this.newLastName = this.lastName;
      },
      updateUserProfile: async function () {
        try {
          const payload = await {
            firstName: this.newFirstName,
            lastName: this.newLastName,
          };
          const api = await new ApiCurrentUser();
          const res = await api.put(payload);
          //await this.$store.dispatch('user/updateUser', payload);
          await this.$store.commit('notification/setMessage', 'Updated');
        } catch (error) {
          console.error(error);
        }
      },
    },
  };
</script>
